exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".processcipform-cssmodule-processcipform-component-2NRZ2{border:1px dashed red;border:none}", ""]);

// exports
exports.locals = {
	"processcipform-component": "processcipform-cssmodule-processcipform-component-2NRZ2"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/ProcessIdeas/processcipform.cssmodule.scss
// module id = 606
// module chunks = 0